import { DataDictionary as DataDictionaryType } from "@aidkitorg/types/lib/survey";
import { PermissionScope } from "@aidkitorg/types/lib/translation/permissions";
import { getDataDictionary } from "@aidkitorg/types/lib/translation/questions";
import { expandTemplates } from "@aidkitorg/types/lib/translation/v0_to_legacy";
import Papa from "papaparse";
import { Button } from "react-bootstrap";
import { usePost } from "../API";

export function DataDictionary(props: { component: DataDictionaryType }) {
  const loadSurvey = usePost('/survey/load_survey');
  const getScope = usePost('/program/enumerate_scope');

  const handleDataDictionaryDownload = async () => {
    const everything = await loadSurvey({ name: 'entireprogram' }) as any;
    const expandedSurvey = expandTemplates(everything) as any;
    const scope = await getScope({});
    const dataDictionary = getDataDictionary(
      expandedSurvey.config.survey,
      (scope as PermissionScope),
      props.component.excludeFields,
      props.component.includeComputations);

    let blob: Blob;
    // Create a new anchor element
    const a = document.createElement('a');

    if (props.component.type === 'json') {
      // Stringify your JSON data.
      const jsonData = JSON.stringify(dataDictionary.rows, null, 2); // `null` and `2` are for formatting with 2-space indentation.
  
      blob = new Blob([jsonData], { type: 'application/json' });
      a.download = 'dataDictionary.json';
    } else if (props.component.type === 'csv') {
      // Convert JSON to csv.
      const csvData = Papa.unparse(dataDictionary.rows, { columns: dataDictionary.columns });

      blob = new Blob([csvData], { type: 'text/csv' });
      a.download = 'dataDictionary.csv';
    } else {
      throw new Error('Unrecognized DataDictionary type' + props.component.type)
    }

    const url = window.URL.createObjectURL(blob);

    // Set the href to the object URL and initiate download.
    a.href = url;

    // This is necessary as some browsers won't support direct .click() on the element without appending it to the DOM.
    document.body.appendChild(a); // Append anchor to body.
    a.click();
    document.body.removeChild(a); // Remove anchor from body after download starts.

    // It's important to revoke the object URL to avoid memory leaks.
    window.URL.revokeObjectURL(url);
  };
  return <div className="my-3">
    <Button variant='outline-primary' className='mx-4'
      onClick={handleDataDictionaryDownload}>
      Get Data Dictionary ( {props.component.type} )
    </Button>
  </div>
}